import FinanceApi from '@/services/FinanceApi';

const getAll = async (config) => {
    return FinanceApi.get('/years', config);
}

const get = async (code) => {
    return FinanceApi.get('/years/' + code);
}

const options = async (config) => {
    return FinanceApi.get('/years/options', config);
}

const getReceiptNumber = async (code) => {
    return FinanceApi.get('/years/' + code + '/receipt/number');
}

const store = async (data) => {
    if (data.id) {
        return FinanceApi.put('/years/' + data.id, data);
    }
    return FinanceApi.post('/years', data);
}

const update = async (id, formData) => {
    return FinanceApi.put('/years/' + id, formData);
}

const deleteyear = async (id) => {
    return FinanceApi.delete('/years/' + id);
}

export default {
    getAll,
    get,
    getReceiptNumber,
    store,
    update,
    deleteyear,
    options
}
